// Otter Assist — the ONE place canonical navigation is decided (OAD-113 / OAD-114).
//
//   View Need → /dashboard/otter-assist/need/:assist_id   (the canonical Need Detail)
//   View Post → /chatter/post/:post_id                    (the canonical original Chatter post)
//
// Return navigation is driven by a `from` value restricted to a fixed internal whitelist. Anything
// unknown, missing, malformed, absolute or protocol-relative falls back to Otter Assist → Community
// Needs, so no arbitrary or external return URL can ever be constructed.

export const OA_ORIGINS = ["community", "my-needs", "assistance-offered", "assistance-received"];

const RETURN_TARGET = {
  community: "/dashboard/otter-assist?tab=community",
  "my-needs": "/dashboard/otter-assist?tab=mine",
  "assistance-offered": "/dashboard/otter-assist?tab=assistance&direction=offered",
  "assistance-received": "/dashboard/otter-assist?tab=assistance&direction=received",
};

/** The only accepted origins. Everything else is discarded rather than sanitised. */
export function safeOrigin(from) {
  return OA_ORIGINS.includes(from) ? from : null;
}

/** Where "Return to Otter Assist" goes. Always an internal Otter Assist path. */
export function returnHref(from) {
  return RETURN_TARGET[safeOrigin(from)] || RETURN_TARGET.community;
}

/** The canonical Need Detail for an Assist — never requires a delivery. */
export function needHref(assistId, from) {
  const origin = safeOrigin(from);
  return `/dashboard/otter-assist/need/${assistId}${origin ? `?from=${origin}` : ""}`;
}

/** The canonical original Chatter post. */
export function postHref(postId, from) {
  const origin = safeOrigin(from);
  return `/chatter/post/${postId}${origin ? `?from=${origin}` : ""}`;
}
